export enum SocialShareType {
  LINKEDIN = 'linkedin',
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  COPY = 'copy',
}
